module.exports = __webpack_public_path__ + "static/media/18ECA16.b7f131d7.jpg";